import React from "react";
import uuid from "react-native-uuid";
import { useApi } from "../../../core/apis";
import { BusinessStatus, BusinessType } from "../../plan/BusinessPlanModel";
import type { BusinessCustomerData } from "../customers/BusinessCustomerModel";

export function useCreateBusinessPlanFromTemplate() {
  const { businessPlansApi, businessTemplatesApi } = useApi();

  return React.useCallback(
    async (
      customerData: BusinessCustomerData,
      title: string,
      templateUid: string,
    ) => {
      const template = await businessTemplatesApi.getById(templateUid);

      if (!template) {
        throw new Error("Template not found!");
      }

      const businessPlan = await businessPlansApi.add({
        status: BusinessStatus.Active,
        type: BusinessType.Regular,
        customerInfo: {
          uid: customerData.uid,
          ...customerData.profile,
        },
        profileQuestions: template.data.profileQuestions,
        feedCount: 0,
        teamsInfo: [],
        feedMediaCount: 0,
        feedLatestEvents: [],
        feedPinnedEvents: [],
        eventInfo: {
          tags: [],
          tasks: [],
          date: null,
          settings: template.data.settings,
        },
        planInfo: { ...template.data.planInfo, title: title },
        sections: [],
        userInfo: {},
      });

      for (const templateData of template.data.businessModules) {
        const m = await businessPlan.addBusinessModule(templateData);
        await businessPlan.addEventModule(m.uid);
      }

      for (const section of template.data.sections) {
        const sectionData = await businessPlan.addSection({
          ...section,
          isVisible: true,
          isDeleted: false,
          uid: uuid.v4(),
        });

        for (const moduleSection of section.businessModules) {
          const m = await businessPlan.addBusinessModule(moduleSection);
          await businessPlan.addSectionModule(sectionData.uid, m.uid);
        }
      }

      for (const scheduleItem of template.data.schedule) {
        await businessPlan.addScheduleItem(scheduleItem);
      }

      return businessPlan;
    },
    [businessPlansApi, businessTemplatesApi],
  );
}
